const stages = {
  PREQUAL: 'PreQualification',
  UNDERWRITING: 'UnderWriting',
  NEWBUSINESS: 'NewBusiness',
  PAYMENT: 'Payment',
};

//** Schemas */

//** paths */

//** Config */
import { Application } from 'src/config/const/enums';
import {
  yourDetailsContactFieldNames,
  selectCoverFieldNames,
  quoteSummaryFieldNames,
  paymentContactDetailsFieldNames,
  aboutYouDisclosureFieldNames,
  aboutYouPersonalInformationFieldNames,
  aboutYouDeclarationsFieldNames,
} from 'src/config/pageInfo/pageFieldName';
import { pageName } from 'src/config/pageInfo/pageNames';
import { pageOrder, pageOrderCC } from 'src/config/pageInfo/pageOrder';
import {
  PATH_ONLINE_SUB,
  PATH_ONLINE_NAVIGATION,
  PATH_CONTACT_CENTER_SUB,
  PATH_CONTACT_CENTER_NAVIGATION,
} from 'src/routes/paths';
// import { schemaPaymentContactDetails } from 'src/schema/paymentContactDetailsSchema';
import {
  schemaYourDetailsContact,
  schemaYourTwoPersonDetailsContact,
  // schemaSelectCover,
  // schemaTwoPersonSelectCover,
  // schemaQuoteSummary,
  // schemaTwoPersonQuoteSummary,
  // aboutYouDisclosureSchema,
  // aboutYouInformationSchema,
  // aboutYouDeclarationSchema,
} from 'src/schema/preQualValidationSchema';

//* ----------------------------------------------------------------

export const sharedPages = (application = Application.ONLINE, person = 'personOne') => {
  const path = application === Application.ONLINE ? PATH_ONLINE_SUB : PATH_CONTACT_CENTER_SUB;
  const navigation =
    application === Application.ONLINE ? PATH_ONLINE_NAVIGATION : PATH_CONTACT_CENTER_NAVIGATION;
  const pageOrderDefault = application === Application.ONLINE ? pageOrder : pageOrderCC;

  const sharedPageDetails = [
    // {
    //   index: pageOrderDefault.GETTING_STARTED,
    //   title: 'Getting Started',
    //   identifier: pageName.GETTING_STARTED,
    //   stage: stages.PREQUAL,
    //   routePath: path.gettingStarted,
    //   nextRoutePath: navigation.contact,
    //   previousRoutePath: navigation.accept,
    //   fieldNames: yourDetailsPersonalFieldNames(person),
    //   showProgressBar: true,
    //   activeStep: 0,
    //   schema: null,
    //   dualSchema: null,
    //   valid: false,
    // },
    {
      index: pageOrderDefault.CONTACT,
      title: 'Your Details: Contact Information',
      identifier: pageName.CONTACT,
      stage: stages.PREQUAL,
      routePath: path.contact,
      nextRoutePath: navigation.cover,
      previousRoutePath: navigation.personal,
      fieldNames: yourDetailsContactFieldNames(person),
      showProgressBar: true,
      activeStep: 0,
      schema: schemaYourDetailsContact(),
      dualSchema: schemaYourTwoPersonDetailsContact(),
      valid: false,
      allowNavigation: true,
    },
    {
      index: pageOrderDefault.COVER,
      title: 'Select Cover',
      identifier: pageName.COVER,
      stage: stages.PREQUAL,
      routePath: path.cover,
      nextRoutePath: navigation.quote,
      previousRoutePath: navigation.gettingStarted,
      fieldNames: selectCoverFieldNames(person),
      showProgressBar: true,
      activeStep: 1,
      // schema: schemaSelectCover(),
      // dualSchema: schemaTwoPersonSelectCover(),
      schema: null,
      dualSchema: null,
      valid: false,
      allowNavigation: true,
    },
    {
      index: pageOrderDefault.QUOTE,
      title: 'Quote Summary',
      identifier: pageName.QUOTE,
      stage: stages.PREQUAL,
      routePath: path.quote,
      nextRoutePath: navigation.saveAndEmail,
      previousRoutePath: navigation.cover,
      fieldNames: quoteSummaryFieldNames(person),
      showProgressBar: true,
      activeStep: 2,
      schema: null,
      dualSchema: null,
      // schema: schemaQuoteSummary(),
      // dualSchema: schemaTwoPersonQuoteSummary(),
      valid: false,
      allowNavigation: true,
    },
    {
      index: pageOrderDefault.ABOUT_YOU_INFORMATION, //* New
      title: 'About You Information',
      identifier: pageName.ABOUT_YOU_INFORMATION,
      stage: stages.PREQUAL,
      routePath: path.aboutYouInformation,
      nextRoutePath: navigation.aboutYouDeclarations, // TODO: need to update the review application route
      previousRoutePath: navigation.saveAndEmail,
      fieldNames: aboutYouPersonalInformationFieldNames(),
      showProgressBar: true,
      activeStep: 3,
      // schema: aboutYouInformationSchema(),
      schema: null,
      valid: false,
      allowNavigation: true,
    },
    {
      index: pageOrderDefault.ABOUT_YOU_DECLARATIONS, //* New
      title: 'About You Declarations',
      identifier: pageName.ABOUT_YOU_DECLARATIONS,
      stage: stages.PREQUAL,
      routePath: path.aboutYouDeclarations,
      nextRoutePath: navigation.ppContact, // TODO: need to update the review application route
      previousRoutePath: navigation.aboutYouInformation,
      fieldNames: aboutYouDeclarationsFieldNames(),
      showProgressBar: true,
      activeStep: 3,
      schema: null,
      // schema: aboutYouDeclarationSchema(),
      valid: false,
      allowNavigation: true,
    },
    {
      index: pageOrder.ABOUT_YOU_DISCLOSURE,
      title: 'About You Duty of Disclosure',
      identifier: pageName.ABOUT_YOU_DISCLOSURE,
      stage: stages.UNDERWRITING,
      routePath: path.aboutYouDisclosure,
      nextRoutePath: navigation.quote, // TODO: need to update the review application route
      previousRoutePath: navigation.quote,
      fieldNames: aboutYouDisclosureFieldNames(),
      showProgressBar: true,
      activeStep: 2,
      schema: null,
      // schema: aboutYouDisclosureSchema(),
      // dualSchema: schemaTwoPersonQuoteSummary(),
      valid: false,
      allowNavigation: true,
    },
    {
      index: pageOrder.ABOUT_YOU_QUESTIONS,
      title: 'About You Questions',
      identifier: pageName.ABOUT_YOU_QUESTIONS,
      stage: stages.UNDERWRITING,
      routePath: path.aboutYouQuestions,
      nextRoutePath: navigation.quote, // TODO: need to update the review application route
      previousRoutePath: navigation.aboutYouDisclosure,
      // fieldNames: quoteSummaryFieldNames(person),
      showProgressBar: true,
      activeStep: 3,
      // schema: schemaQuoteSummary(),
      // dualSchema: schemaTwoPersonQuoteSummary(),
      valid: false,
      allowNavigation: true,
    },
    {
      index: pageOrder.REVIEW_APPLICATION,
      title: 'Review application',
      identifier: pageName.REVIEW_APPLICATION,
      stage: stages.UNDERWRITING,
      routePath: path.aboutYourReview,
      nextRoutePath: navigation.quote, // TODO: need to update the review application route
      previousRoutePath: navigation.aboutYouDisclosure,
      // fieldNames: quoteSummaryFieldNames(person),
      showProgressBar: true,
      activeStep: 4,
      // schema: schemaQuoteSummary(),
      // dualSchema: schemaTwoPersonQuoteSummary(),
      valid: false,
      pageIndicator: 'L60',
      allowNavigation: true,
    },
    {
      index: pageOrderDefault.PP_CONTACT,
      title: 'Payment Contact Details',
      identifier: pageName.PP_CONTACT,
      stage: stages.PAYMENT,
      routePath: path.ppContact,
      nextRoutePath: navigation.ppOnlinePayment,
      previousRoutePath: navigation.quote,
      fieldNames: paymentContactDetailsFieldNames(),
      showProgressBar: true,
      activeStep: 6,
      schema: null,
      // schema: schemaPaymentContactDetails(),
      dualSchema: null,
      valid: false,
      pageIndicator: 'L90',
      allowNavigation: true,
    },
    {
      index: pageOrderDefault.PP_POLICY_OUTCOME_DECLINE,
      title: 'Policy Outcome Decline',
      identifier: pageName.PP_POLICY_OUTCOME_DECLINE,
      stage: stages.PAYMENT,
      routePath: path.ppPolicyOutcomeDecline,
      nextRoutePath: null,
      previousRoutePath: null,
      fieldNames: null,
      showProgressBar: false,
      activeStep: 3,
      schema: null,
      dualSchema: null,
      valid: false,
      allowNavigation: false,
    },
    {
      index: pageOrderDefault.PP_CONFIRMATION,
      title: 'Policy Purchase Confirmation',
      identifier: pageName.PP_CONFIRMATION,
      stage: stages.PAYMENT,
      routePath: path.ppConfirmation,
      nextRoutePath: null,
      previousRoutePath: navigation.ppOnlinePayment,
      fieldNames: null,
      showProgressBar: false,
      activeStep: null,
      schema: null,
      dualSchema: null,
      valid: false,
      allowNavigation: true,
    },
    // Retrieve common pages for CC and ONLINE
    {
      index: pageOrderDefault.RETRIEVE_QUOTE_LOADING,
      title: 'Retrieve Quote Loading',
      identifier: pageName.RETRIEVE_QUOTE_LOADING,
      stage: stages.PREQUAL,
      routePath: path.retrieveQuoteLoading,
      nextRoutePath: null,
      previousRoutePath: null,
      fieldNames: null,
      showProgressBar: true,
      activeStep: 0,
      schema: null,
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
      allowNavigation: true,
    },
    {
      index: pageOrderDefault.RETRIEVE_DECLINE,
      title: 'Retrieve Quote Decline',
      identifier: pageName.RETRIEVE_QUOTE_DECLINE,
      stage: 'Outcome',
      routePath: path.retrieveDecline,
      nextRoutePath: null,
      previousRoutePath: null,
      fieldNames: null,
      showProgressBar: false,
      activeStep: 0,
      schema: null,
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
      allowNavigation: false,
    },
    {
      index: pageOrderDefault.RETRIEVE_EXPIRED,
      title: 'Retrieve Quote Expired',
      identifier: pageName.RETRIEVE_QUOTE_EXPIRED,
      stage: 'Outcome',
      routePath: path.retrieveExpired,
      nextRoutePath: null,
      previousRoutePath: null,
      fieldNames: null,
      showProgressBar: false,
      activeStep: 0,
      schema: null,
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
      allowNavigation: false,
    },
    {
      index: pageOrderDefault.RETRIEVE_REFERRED_UW,
      title: 'Retrieve Quote Referred Underwriter',
      identifier: pageName.RETRIEVE_QUOTE_REFERRED_UW,
      stage: 'Outcome',
      routePath: path.retrieveReferredUW,
      nextRoutePath: null,
      previousRoutePath: null,
      fieldNames: null,
      showProgressBar: false,
      activeStep: 0,
      schema: null,
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
      allowNavigation: false,
    },
    {
      index: pageOrderDefault.RETRIEVE_BOUND,
      title: 'Retrieve Quote Bound',
      identifier: pageName.RETRIEVE_QUOTE_BOUND,
      stage: 'Outcome',
      routePath: path.retrieveBound,
      nextRoutePath: null,
      previousRoutePath: null,
      fieldNames: null,
      showProgressBar: false,
      activeStep: 0,
      schema: null,
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
      allowNavigation: false,
    },
    {
      index: pageOrderDefault.APPLICATION_ALREADY_DECLINED,
      title: 'Application already declined',
      identifier: pageName.APPLICATION_ALREADY_DECLINED,
      stage: 'Outcome',
      routePath: path.applicationAlreadyDeclined,
      nextRoutePath: null,
      previousRoutePath: null,
      fieldNames: null,
      showProgressBar: false,
      activeStep: 0,
      schema: null,
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
      allowNavigation: false,
    },
  ];

  return sharedPageDetails;
};
